export const appId = 'bible-glen';
export const appTitle = 'Bible Glen';

export const firebaseConfig = {
    apiKey: "AIzaSyAstJjSXNcttsPX2j4bAa9lU1EXtUeqv5g",
    authDomain: "bibleglen.com",
    projectId: "bible-glen",
    storageBucket: "bible-glen.firebasestorage.app",
    messagingSenderId: "379782740555",
    appId: "1:379782740555:web:e2205a55bea9e972a1ebce",
    measurementId: "G-RL81235QV5"
};

export const flag_offline_timeout = 5000;

export const shouldAllowLocalFunctions = false;

export const isLocal = window.location.host.includes('localhost');

export const functionsUrl = isLocal
    ? 'http://localhost:5001/bible-glen/us-central1'
    : 'https://us-central1-bible-glen.cloudfunctions.net';